<div class="zas-width">
    <h1>
        Beratungsdokumentation
        <span class="header-version">{{ buildVersion }}</span>
        <div *ngIf="!zbdGlobals.embedded" class="main-menu-container">
            <zbd-main-menu [hasHome]="false">
                <li *ngIf="showDownloadOption()">
                    <a (click)="zipDownloadModal.open()">
                        <span class="icon-link prefix-icon"></span
                        >&nbsp;Zip-Download
                    </a>
                </li>
            </zbd-main-menu>
        </div>
    </h1>
    <zbd-search-form
        (onSearchResultsUpdate)="onSearchResultsUpdate($event)"
        (onSearchFailed)="onSearchFailed($event)"
        (onCreateFailed)="onCreateFailed($event)"
    ></zbd-search-form>
    <zbd-search-results
        [consultationProcessSearchResults]="searchResults"
        [moreResults]="moreResults"
        [searching]="searching"
        (onSearchMore)="onSearchMore()"
    ></zbd-search-results>
</div>
<zbd-zip-download></zbd-zip-download>
